const useCategory = () => {
  const drawerMenu = [];

  return {
    drawerMenu,
  };
};

export default useCategory;
